import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useHistory } from 'react-router';
import { Country } from '@tiendanube/common/src/enums';
import HelpLink from 'App/HelpLink/HelpLink';
import { CAN_LINK_ABOUT_PRODUCTS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import { useGetCountry } from 'domains/Auth/hooks';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import {
  trackingCoreProductAddOnboardingClick,
  trackingCoreProductImportOnboardingClick,
} from 'domains/Catalog/Products/tracking';
import DropshippingAppCard from './DropshippingAppCard';
import emptyProducts from './empty-products.png';

function ProductListEmpty() {
  const t = useTranslationCatalog();
  const { push } = useHistory();
  const storeCountry = useGetCountry();
  const language = useTranslationLanguage();
  const onClickAddProduct = () => {
    trackingCoreProductAddOnboardingClick();
    push('/products/new');
  };
  const onClickImport = () => {
    trackingCoreProductImportOnboardingClick();
    push('/products/import/onboarding');
  };

  const shouldShowDropshipping = storeCountry === Country.BR;

  const bodyDescription = (
    <p>
      {t('products.emptyResults.body.first_paragraph')}
      <br />
      {t('products.emptyResults.body.second_paragraph')}
    </p>
  );
  return (
    <InitialScreen>
      <InitialScreen.Hero
        title={t('products.emptyResults.title')}
        subtitle={t('products.title').toUpperCase()}
        description={bodyDescription}
        image={
          <img
            src={emptyProducts}
            width="100%"
            height="auto"
            alt="empty-products"
          />
        }
        actions={
          <Box>
            <Box display="flex" gap="4" flexWrap="wrap">
              <Button appearance="primary" onClick={onClickAddProduct}>
                {t('products.emptyResults.action_primary')}
              </Button>
              <Button appearance="neutral" onClick={onClickImport}>
                {t('products.emptyResults.action_secondary')}
              </Button>
            </Box>
            {shouldShowDropshipping && (
              <InitialScreen.Module
                title={t('products.emptyResults.dropshipping.title')}
                description={t('products.emptyResults.dropshipping.body')}
                gap="4"
                paddingTop="8"
              >
                <Box>
                  <Box>
                    <DropshippingAppCard />
                  </Box>
                </Box>
              </InitialScreen.Module>
            )}
          </Box>
        }
      />
      <Box
        display="flex"
        flexDirection="row"
        gap="2"
        justifyContent="center"
        mt="5"
      >
        <HelpLink
          title={t('helpLink.aboutProducts')}
          linkURL={CAN_LINK_ABOUT_PRODUCTS[language]}
          currentViewTracking={t('helpLink.aboutProductsTrackingName')}
          previousValue="product_list"
          icon="both"
          showInMobile
        />
      </Box>
    </InitialScreen>
  );
}

export default ProductListEmpty;
